import { useNavigate } from "react-router-dom";
// Chakra Icons
import { BellIcon } from "@chakra-ui/icons";
// Chakra Imports
import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuDivider,
  MenuGroup,
  Text,
  Stack,
  Box,
  useColorMode,
  useColorModeValue,
  AvatarGroup,
  Avatar,
  Portal,
} from "@chakra-ui/react";
// auth
import useLogout from "hooks/useLogout";
// Assets
import avatar1 from "assets/img/avatars/Lex.png";
// Custom Icons
import { SettingsIcon } from "components/Icons/Icons";
import { FaSun } from "react-icons/fa6";
import { IoMoon } from "react-icons/io5";

// Custom Components
import { ItemContent } from "components/Menu/ItemContent";
import { SearchBar } from "components/Navbars/SearchBar/SearchBar";
import { SidebarResponsive } from "components/Sidebar/Sidebar";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import routes from "routes.js";
import {
  ArgonLogoDark,
  ChakraLogoDark,
  ArgonLogoLight,
  ChakraLogoLight,
} from "components/Icons/Icons";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import { getUser } from "api/requests/getUser";

export default function HeaderLinks(props) {
  const {
    variant,
    children,
    fixed,
    scrolled,
    secondary,
    onOpen,
    ...rest
  } = props;
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  const [user, setUser] = useState();

  const { colorMode, toggleColorMode } = useColorMode();

  const storedUser = localStorage.getItem("user");
  const username = storedUser ? storedUser : "Sign In";
  const logout = useLogout();

  useEffect(() => {
    getUser(axiosPrivate).then((user) => setUser(user));
  }, []);

  const signOut = async () => {
    await logout();
  };

  // Chakra Color Mode
  let navbarIcon =
    fixed && scrolled
      ? useColorModeValue("white", "gray.200")
      : useColorModeValue("white", "gray.200");
  let menuBg = useColorModeValue("white", "navy.800");
  if (secondary) {
    navbarIcon = "white";
  }
  let iconColor = useColorModeValue("yellow", "orange");
  return (
    <Flex
      pe={{ sm: "0px", md: "16px" }}
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
      flexDirection="row"
      zIndex="9996"
    >
      <SearchBar me="18px" />
      <Menu me={{ sm: "2px", md: "16px" }}>
        <MenuButton
          px={4}
          py={1}
          mr={4}
          transition={"all 0.2s"}
          borderRadius={"md"}
          color={navbarIcon}
          _hover={{ bg: "blue.400" }}
          _expanded={{ bg: "blue.400" }}
          _focus={{ boxShadow: "outline" }}
        >
          <Flex align={"center"}>
            <Avatar
              src={user?.image}
              border={"1px"}
              bg={"blue.300"}
              size={"sm"}
              mr={3}
            />
            <Text>{user?.username}</Text>
          </Flex>
        </MenuButton>
        <Portal>
          <MenuList zIndex="9997">
            <MenuGroup title="Profile">
              <MenuItem
                onClick={() =>
                  navigate("/admin/my-account/", { replace: true })
                }
              >
                My Account
              </MenuItem>
              <MenuItem onClick={signOut} _hover={{ bg: "red.500" }}>
                Logout{" "}
              </MenuItem>
            </MenuGroup>
            <MenuDivider />
            <MenuGroup title="Help">
              <MenuItem
                onClick={() =>
                  navigate("/landing/knowledgebase", { replace: true })
                }
              >
                Knowledge Base
              </MenuItem>
              <MenuItem>FAQ</MenuItem>
            </MenuGroup>
          </MenuList>
        </Portal>
      </Menu>
      <SidebarResponsive
        logo={
          <Stack direction="row" spacing="12px" align="center" justify="center">
            {colorMode === "dark" ? (
              <ArgonLogoLight w="74px" h="27px" />
            ) : (
              <ArgonLogoDark w="74px" h="27px" />
            )}
            <Box
              w="1px"
              h="20px"
              bg={colorMode === "dark" ? "white" : "gray.700"}
            />
            {colorMode === "dark" ? (
              <ChakraLogoLight w="82px" h="21px" />
            ) : (
              <ChakraLogoDark w="82px" h="21px" />
            )}
          </Stack>
        }
        colorMode={colorMode}
        secondary={props.secondary}
        routes={routes}
        {...rest}
      />
      {colorMode === "dark" ? (
        <FaSun
          cursor="pointer"
          ms={{ base: "16px", xl: "0px" }}
          me="16px"
          onClick={toggleColorMode}
          color={iconColor}
          size="20px"
        />
      ) : (
        <IoMoon
          cursor="pointer"
          ms={{ base: "16px", xl: "0px" }}
          me="16px"
          onClick={toggleColorMode}
          color={iconColor}
          size="20px"
        />
      )}
      <SettingsIcon
        cursor="pointer"
        ms={{ base: "16px", xl: "22px" }}
        me="16px"
        onClick={props.onOpen}
        color={navbarIcon}
        w="24px"
        h="24px"
      />
      <Menu>
        <MenuButton>
          <BellIcon color={navbarIcon} w="24px" h="24px" />
        </MenuButton>
        <Portal>
          <MenuList p="16px 8px" bg={menuBg} zIndex="9998">
            <Flex flexDirection="column">
              <MenuItem borderRadius="md" mb="10px">
                <ItemContent
                  time="13 minutes ago"
                  info="by Lex"
                  boldInfo="New Client Added"
                  aName="Lex"
                  aSrc={avatar1}
                />
              </MenuItem>
              <MenuItem borderRadius="md" mb="10px">
                <ItemContent
                  time="2 days ago"
                  info="by Lex"
                  boldInfo="New User PickleRick Added"
                  aName="Lex"
                  aSrc={avatar1}
                />
              </MenuItem>
              <MenuItem borderRadius="md">
                <ItemContent
                  time="3 days ago"
                  info="by Lex"
                  boldInfo="New EBlast completed"
                  aName="Lex"
                  aSrc={avatar1}
                />
              </MenuItem>
            </Flex>
          </MenuList>
        </Portal>
      </Menu>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
